var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1,
    y1: 0.038,
    x2: 0,
    y2: 0.972,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d9dbe2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515b7e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-active",
    x1: 1.088,
    y1: 0.063,
    x2: -0.037,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ca79ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.483,
    stopColor: "#ffe4d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76daff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_Home",
    "data-name": "Icon/Home",
    d: "M9.5,22.75a1.524,1.524,0,0,1-1.062-.4A1.255,1.255,0,0,1,8,21.388V12.537a1.254,1.254,0,0,1,.163-.613,1.331,1.331,0,0,1,.438-.477l6.5-4.426a1.549,1.549,0,0,1,.425-.2,1.691,1.691,0,0,1,.95,0,1.549,1.549,0,0,1,.425.2l6.5,4.426a1.331,1.331,0,0,1,.438.477,1.254,1.254,0,0,1,.163.613v8.851a1.255,1.255,0,0,1-.437.965,1.524,1.524,0,0,1-1.062.4H18V16.4H14V22.75Z",
    transform: "translate(-8 -6.75)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/HomeIcon.493034d2bc9a789d5b34eda26d842ec5.svg";
export { ForwardRef as ReactComponent };